import { render, staticRenderFns } from "./contextMenu.vue?vue&type=template&id=63d0e530&scoped=true&"
import script from "./contextMenu.vue?vue&type=script&lang=js&"
export * from "./contextMenu.vue?vue&type=script&lang=js&"
import style0 from "./contextMenu.vue?vue&type=style&index=0&id=63d0e530&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d0e530",
  null
  
)

component.options.__file = "contextMenu.vue"
export default component.exports